<div id="timestamp-wrapper" (contextmenu)="onContextMenu($event)">
  <div id="timestamp-container">
    <div id="timestamp-content">
      @if (type == 'above') {
        <div id="milestones">
          @for (e of $any(data); track e) {
            @if (e.type == 'ctmsmilestone') {
              <app-ctmsmilestone [milestone]="e.entry"></app-ctmsmilestone>
            } @else if (e.type == 'custom-milestone') {
              <app-custom-milestone [customMilestone]="e.entry" (deleteCustomMilestone)="onDelete($event)"></app-custom-milestone>
            } @else if (e.type == 'congress-event') {
              <app-congress-milestone [congress]="e.entry" milestoneType="event"></app-congress-milestone>
            } @else if (e.type == 'congress-abstract') {
              <app-congress-milestone [congress]="e.entry" milestoneType="abstractDue"></app-congress-milestone>
            } @else if (e.type == 'congress-latebreaking') {
              <app-congress-milestone [congress]="e.entry" milestoneType="lateBreaking"></app-congress-milestone>
            }
          }
        </div>
      } @else if (type == 'below') {
        <div id="publications">
          @for (e of $any(data); track e) {
            @if(e.type == 'publication'){
              <app-publication [publication]="e.entry"></app-publication>
            } @else if (e.type == 'activity'){
              <app-activity [activity]="e.entry" (deleteActivity)="onDelete($event)"></app-activity>
            } @else if (e.type == 'vvpm-activity'){
              <app-vvpm-activity [vvpmActivity]="e.entry"></app-vvpm-activity>
            }
          }
        </div>
      }
    </div>
  </div>
</div>
